import React, { useEffect, useState } from "react";
import {
  Button,
  Flex,
  Loader,
  Radio,
  RadioGroupField,
  TextField,
  Text,
  PasswordField,
  View,
  Icon,
  Alert
} from "@aws-amplify/ui-react";
import "./Badanti.css";
import { checkBadanteAPI, checkBadanteNomeCognomeAPI, checkBadanteTelefonoAPI, createBadanteBozzaAPI, createUserAPI, generateContrattoBadante, modifyBadanteAPI } from "../../data/api";
import BadanteBozzaForm from "./BadanteBozzaForm";
import { NavLink, useNavigate } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";
import { endOfToday, format } from "date-fns";
import { formConfig } from "./config";
import { Modal } from "react-bootstrap";

const defaultForm = {
  Nome: "",
  Cognome: "",
  Telefono: "+39"
};

const CreateBadanteBozzaForm = (props) => {
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [errorCreate, setErrorCreate] = useState(false);
  const navigate = useNavigate();

  // create BadanteBozza form data
  const [createBadanteBozzaFormValues, setCreateBadanteBozzaFormValues] = useState(() => {
    const storage = localStorage.getItem('createBadanteBozzaFormValues');
    return storage ? JSON.parse(storage) : defaultForm;
  });

  const changeInputCreateBadanteBozzaForm = (e) => {
    const { name, value } = e.target;
    const newValue = { ...createBadanteBozzaFormValues };
    name.split('.').reduce((acc, key, idx, arr) => 
      acc[key] = idx === arr.length - 1 ? value : acc[key] || {}, newValue);
    setCreateBadanteBozzaFormValues(newValue);
    localStorage.setItem('createBadanteBozzaFormValues', JSON.stringify(newValue));
  };

  const resetCreateBadanteBozzaForm = () => {
    setCreateBadanteBozzaFormValues(defaultForm);
    localStorage.setItem('createBadanteBozzaFormValues', JSON.stringify(defaultForm));
  }

  const createBadanteBozza = async (attivo) => {
    try{
      setLoadingCreate(true);
      setErrorCreate(false);
      let response;
      if(attivo !== 'Bozza'){
        // check if documentazione is completa
        if(showAlertPermessoSoggiorno || showAlertDocumenti){
          attivo = 'Incompleto'
        // check if disponibilità is futura
        } else if(createBadanteBozzaFormValues['Data_Disponibilita'] === undefined 
          || createBadanteBozzaFormValues['Data_Disponibilita'] === null 
          || createBadanteBozzaFormValues['Data_Disponibilita'] > format(new Date(), 'yyyy-MM-dd')){
            attivo = 'Impegnato altrove'
        }
        response = await createBadanteBozzaAPI({...createBadanteBozzaFormValues, Attivo: attivo});
        const responseScheda = await generateContrattoBadante(response.badante_id);
        await modifyBadanteAPI({...createBadanteBozzaFormValues, ID: response.badante_id, Contratto: responseScheda.contratto_path, Contratto_Esteso: responseScheda.contratto_esteso_path, Attivo: attivo});
      } else {
        response = await createBadanteBozzaAPI({...createBadanteBozzaFormValues, Attivo: attivo});
      }
      const idBadante = response.badante_id ?? ''
      setLoadingCreate(false);
      console.log(idBadante, response, 'os/bozze/detail?id='+idBadante)
      if(idBadante !== '' && attivo === 'Bozza'){
        navigate('/os/bozze/detail?id='+idBadante)
      } else if(idBadante !== '' && attivo !== 'Bozza') {
        navigate('/os/detail?id='+idBadante)
      } else {
        navigate('/os/bozze')
      }
      resetCreateBadanteBozzaForm();
    } catch (e) {
      console.log('Create Badante Bozza failed ', e);
      setErrorCreate(true);
      setLoadingCreate(false);
    }
  };

  // check if duplicate
  const [showAlertDuplicate, setShowAlertDuplicate] = useState(false);
  const checkBadanteDuplicato = async () => {
    const nome = createBadanteBozzaFormValues['Nome'];
    const cognome = createBadanteBozzaFormValues['Cognome'];
    const telefono = createBadanteBozzaFormValues['Telefono'];
    if(nome !== '' && cognome !== '' && telefono !== '' && nome !== null && cognome !== null && telefono !== null){
      try{
        const check = await checkBadanteAPI(nome, cognome, telefono);
        if(check.exists){
          setShowAlertDuplicate(true);
        } else {
          setShowAlertDuplicate(false);
        }
      } catch (e) {
        console.log('Check badante failed ', e);
        setShowAlertDuplicate(false);
      }
    } else {
      setShowAlertDuplicate(false);
    }
  }

  // check if nome cognome is duplicate
  const [showAlertNomeCognomeDuplicate, setShowAlertNomeCognomeDuplicate] = useState(false);
  const checkBadanteNomeCognomeDuplicato = async () => {
    const nome = createBadanteBozzaFormValues['Nome'];
    const cognome = createBadanteBozzaFormValues['Cognome'];
    if(nome !== '' && cognome !== '' && nome !== null && cognome !== null) {
      try{
        const check = await checkBadanteNomeCognomeAPI(nome, cognome);
        if(check.exists){
          setShowAlertNomeCognomeDuplicate(true);
        } else {
          setShowAlertNomeCognomeDuplicate(false);
        }
      } catch (e) {
        console.log('Check badante nome cognome failed ', e);
        setShowAlertNomeCognomeDuplicate(false);
      }
    } else {
      setShowAlertNomeCognomeDuplicate(false);
    }
  }

  const [showAlertTelefonoDuplicate, setShowAlertTelefonoDuplicate] = useState(false);
  const checkBadanteTelefonoDuplicato = async () => {
    const telefono = createBadanteBozzaFormValues['Telefono'];
    if(telefono !== '' && telefono !== null) {
      try{
        const check = await checkBadanteTelefonoAPI(telefono);
        if(check.exists){
          setShowAlertTelefonoDuplicate(true);
        } else {
          setShowAlertTelefonoDuplicate(false);
        }
      } catch (e) {
        console.log('Check badante telefono failed ', e);
        setShowAlertTelefonoDuplicate(false);
      }
    } else {
      setShowAlertTelefonoDuplicate(false);
    }
  }

  const onBlurField = (e) => {
    if(e.target.name === 'Nome' || e.target.name === 'Cognome' || e.target.name === 'Telefono'){
      checkBadanteDuplicato()
    }
    if(e.target.name === 'Nome' || e.target.name === 'Cognome'){
      checkBadanteNomeCognomeDuplicato()
    }
    if(e.target.name === 'Telefono'){
      checkBadanteTelefonoDuplicato()
    }
  }

  useEffect(() => {
    checkBadanteDuplicato()
    checkBadanteNomeCognomeDuplicato()
    checkBadanteTelefonoDuplicato()
  }, []);


  const [isSchedaButtonDisabled, setIsSchedaButtonDisabled] = useState(true);
  useEffect(() => {
    const isAnyFieldEmpty = formConfig.sections
      .flatMap(section => section.fields)
      .filter(field => (field.isRequiredScheda ?? false))
      .map(field => field.name)
      .some(field => !createBadanteBozzaFormValues[field] 
        || createBadanteBozzaFormValues[field] === '' 
        || JSON.stringify(createBadanteBozzaFormValues[field]) === '{}');
    setIsSchedaButtonDisabled(isAnyFieldEmpty);
  }, [createBadanteBozzaFormValues]);

  const [missingAttributesScheda, setMissingAttributesScheda] = useState([]);
  useEffect(() => {
    setMissingAttributesScheda(formConfig.sections
      .flatMap(section => section.fields)
      .filter(field => (field.isRequiredScheda ?? false))
      .filter(field => !createBadanteBozzaFormValues[field.name] 
        || createBadanteBozzaFormValues[field.name] === '' 
        || JSON.stringify(createBadanteBozzaFormValues[field.name]) === '{}')
      .map(f => f.label));
  }, [createBadanteBozzaFormValues]);

  const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(true);
  useEffect(() => {
    const isAnyFieldEmpty = formConfig.sections
      .flatMap(section => section.fields)
      .filter(field => (field.isRequired ?? false))
      .map(field => field.name)
      .some(field => !createBadanteBozzaFormValues[field] 
        || createBadanteBozzaFormValues[field] === '' 
        || JSON.stringify(createBadanteBozzaFormValues[field]) === '{}');
      setIsSaveButtonDisabled(isAnyFieldEmpty);
  }, [createBadanteBozzaFormValues]);

  // confirm generate button modal state
  const [isModalVisible, setIsModalVisible] = useState(false);

  // alert permesso soggiorno
  const [showAlertPermessoSoggiorno, setShowAlertPermessoSoggiorno] = useState(false);
  useEffect(() => {
    setShowAlertPermessoSoggiorno(
      (createBadanteBozzaFormValues['Italiano'] === 'No' &&
      createBadanteBozzaFormValues['Comunita_Europea'] === 'No') &&
      (createBadanteBozzaFormValues['Documenti'] ?? []).map(d => d.Tipo).find(t => t === 'Permesso di soggiorno' || t === 'Visto') === undefined
    )
  }, [createBadanteBozzaFormValues]);

  // alert documento riconoscimento
  const [showAlertDocumenti, setShowAlertDocumenti] = useState(false);
  useEffect(() => {
    setShowAlertDocumenti(
      (createBadanteBozzaFormValues['Documenti'] ?? []).map(d => d.Tipo).find(t => t === 'Carta di identità' || t === 'Passaporto' || t === 'Patente') === undefined
    )
  }, [createBadanteBozzaFormValues]);

  return (
    <View maxWidth="100%" padding="0rem" minHeight="100vh">
      <View
        backgroundColor="var(--amplify-colors-white)"
        borderRadius="6px"
        maxWidth="100%"
        padding="1rem"
      >
        <View marginBottom="10px">
            <NavLink to='/os/bozze' className="amplify-link"><Icon as={MdArrowBack}></Icon> Torna indietro</NavLink>
        </View>
        <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px'
        }}>
            <h2>Nuova bozza operatore sanitario</h2>
            <View>
              <Button
                onClick={() => createBadanteBozza('Bozza')}
                variation="primary"
                disabled={loadingCreate || isSaveButtonDisabled || showAlertDuplicate}
                width={"fit-content"}
                alignSelf={"right"}
              >
                {loadingCreate ? <Loader/> : "Salva nuova bozza"}
              </Button>
              <Button
                onClick={() => setIsModalVisible(true)}
                disabled={loadingCreate || isSchedaButtonDisabled || showAlertDuplicate}
                width={"fit-content"}
                alignSelf={"right"}
                marginLeft={"20px"}
              >
                {loadingCreate ? <Loader/> : "Salva e genera scheda"}
              </Button>
              { errorCreate ? <View><span style={{color: "red", marginLeft: "auto"}}>Errore nella creazione!</span></View> : ""}
            </View>
        </div>
        <Flex as="form" direction="column">
            {showAlertDuplicate && <Alert variation="error">Attenzione: esiste già un OS con questa anagrafica di base. Controllare la presenza di eventuali duplicati già inseriti.</Alert>}
            <Alert variation="warning">Attenzione: la bozza non è stata ancora salvata.</Alert>
            {showAlertNomeCognomeDuplicate && !showAlertDuplicate && <Alert variation="warning">Attenzione: esiste già un OS con lo stesso nome e cognome. Controllare la presenza di eventuali duplicati già inseriti.</Alert>}
            {showAlertTelefonoDuplicate && !showAlertDuplicate && <Alert variation="warning">Attenzione: esiste già un OS con lo stesso numero di telefono. Controllare la presenza di eventuali duplicati già inseriti.</Alert>}
            {(createBadanteBozzaFormValues.CF === null || createBadanteBozzaFormValues.CF === undefined || createBadanteBozzaFormValues.CF === '') && 
            <Alert variation="warning">Attenzione: codice fiscale non specificato.</Alert>}
            {showAlertPermessoSoggiorno && <Alert variation="warning">Attenzione: l'OS non fa parte della Comunità Europea o non possiede cittadinanza italiana, è necessario caricare il permesso di soggiorno o il visto per completarne la documentazione.</Alert>}
            {showAlertDocumenti && <Alert variation="warning">Attenzione: documento di riconoscimento mancante (carta d'identità, patente o passaporto).</Alert>}
            {missingAttributesScheda.length > 0 && 
              <Alert variation="info">Attenzione: non sono stati compilati tutti i campi obbligatori per il contratto ({missingAttributesScheda.join(', ')}).</Alert>}
            <BadanteBozzaForm
                formConfig={formConfig}
                value={createBadanteBozzaFormValues}
                savedValue={createBadanteBozzaFormValues}
                onChange={changeInputCreateBadanteBozzaForm}
                onBlur={onBlurField}
                typeForm="Bozza">
            </BadanteBozzaForm>
            <View textAlign={"right"}>
              <Button
                onClick={() => createBadanteBozza('Bozza')}
                variation="primary"
                disabled={loadingCreate || isSaveButtonDisabled || showAlertDuplicate}
                width={"fit-content"}
                alignSelf={"right"}
              >
                {loadingCreate ? <Loader/> : "Salva nuova bozza"}
              </Button>
              <Button
                onClick={() => setIsModalVisible(true)}
                disabled={loadingCreate || isSchedaButtonDisabled || showAlertDuplicate}
                width={"fit-content"}
                alignSelf={"right"}
                marginLeft={"20px"}
              >
                {loadingCreate ? <Loader/> : "Salva e genera scheda"}
              </Button>
            </View>
        { errorCreate ? <span style={{color: "red", marginLeft: "auto"}}>Errore nella creazione!</span> : ""}
        </Flex>
      </View>
      <Modal show={isModalVisible} onHide={() => setIsModalVisible(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Conferma generazione scheda</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Text>Sei sicuro di voler generare la scheda per l'operatore sanitario?</Text>
        </Modal.Body>
        <Modal.Footer>
          <Button variation="primary" onClick={async () => {setIsModalVisible(false); await createBadanteBozza('Disponibile');}}>Conferma</Button>
        </Modal.Footer>
      </Modal>
    </View>
  );
};

export default CreateBadanteBozzaForm;
